// extracted by mini-css-extract-plugin
export default {"gridSpinner":"ReportsGrid_gridSpinner__xeHIb"};